// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"126":"data","443":"about","464":"search","875":"connector","958":"discovery"}[chunkId] || chunkId) + "." + {"94":"77f6845b","126":"41b2df45","443":"7bbda04f","464":"973f317a","875":"6b9b8bff","936":"44b6b987","958":"2c384e52"}[chunkId] + ".js";
};